import React, { Component } from 'react';
import { StarRating, TagGroup } from 'v1/components/shared';
import { htmlStringParser, truncateString } from 'v1/helpers/misc';
import {
  convertToWholeUnit,
  currencyFormatter
} from 'v1/helpers/currencyHelper';
import {
  convertInchesToFeet,
  displayDimension,
  displayMeasurement
} from 'v1/helpers/measurements/measurementsHelper';
import Text from 'react-format-text';
import { get, isEmpty } from 'lodash';
import moment from 'moment-timezone';
import classnames from 'classnames';

import './Cell.scss';
import { displayDateRange } from 'v1/helpers/byType/dateHelper';
import { unitFieldUtils } from '../../../../../../v4/shared/components/forms/input/unit-field-utils.js';
import { publicInstance } from 'v5/i18n.public';
import { socialResolvers } from 'v5/core/contact-details/social/socialResolvers';

const CELL_MAX_LENGTH = 130;

// TODO: An incredibly old component. I'm sure will be undergoin refactoring when tables are built.

export default class Cell extends Component {
  constructor(props) {
    super(props);
    this.state = { isEditing: false };
  }
  renderText = (value, field) => {
    if (typeof value === 'string') {
      switch (field) {
        case 'websites.0.value_1':
          return (
            <div className="RosterTable-row-cellContent-linkContainer Parent_hoverListener">
              <a
                rel="noopener noreferrer"
                className="RosterTable-row-cellContent-link-item trunc"
                href={htmlStringParser(value)}
                target="_blank"
                onClick={e => {
                  e.stopPropagation();
                }}
              >
                {value}
              </a>{' '}
              <a
                className="Child_hoverListener"
                title="Open in new window"
                onClick={() => {
                  window.open(
                    htmlStringParser(value),
                    '_blank',
                    'location=yes,height=600,width=600,scrollbars=yes,status=yes'
                  );
                }}
              >
                <img src="/images/icon_new_window.svg" width="10px" alt="" />
              </a>
            </div>
          );
        case 'email':
          return (
            <a
              href={`mailto:${value}`}
              target="_blank"
              className="trunc"
              rel="noopener noreferrer"
              onClick={e => {
                e.stopPropagation();
              }}
            >
              {value}
            </a>
          );
        case 'notes':
          return (
            <span
              className="latestNote trunc"
              data-tip={
                value.note && value.note.length > CELL_MAX_LENGTH
                  ? value.note
                  : null
              }
            >
              {truncateString(value.note || value, CELL_MAX_LENGTH)}
              <br />
              {value.user && (
                <span className="latestNote-author">
                  {value.user.first_name} &middot;{' '}
                  {moment(value.created_at).fromNow()}
                </span>
              )}
            </span>
          );
        default:
          return (
            <span
              className="trunc"
              data-tip={value.length > CELL_MAX_LENGTH ? value : null}
            >
              <Text>{truncateString(value, CELL_MAX_LENGTH)}</Text>
            </span>
          );
      }
    }
  };
  renderEmptyField = () => {
    return '--';
  };
  renderCellType = () => {
    // Handle boolean type first with explicit null/undefined handling
    if (this.props.type === 'boolean') {
      switch (this.props.value) {
        case true:
          return publicInstance.t('ds:TernaryToggle.yes');
        case false:
          return publicInstance.t('ds:TernaryToggle.no');
        default:
          return publicInstance.t('ds:TernaryToggle.emptyValue');
      }
    }

    if (
      (typeof this.props.value === 'object' ||
        Array.isArray(this.props.value)) &&
      (isEmpty(this.props.value) || !this.props.value)
    )
      return this.renderEmptyField();

    switch (this.props.type) {
      case 'composite':
        return this.props.value.component;
      case 'social':
        const socialProvider = this.props.field?.split('social_')[1];
        const resolver = socialResolvers[socialProvider];
        const parsedResult = resolver?.parseInput(this.props.value || '');

        if (!parsedResult?.fullUrl) {
          return this.props.value || this.renderEmptyField();
        }

        return (
          <a
            rel="noopener noreferrer"
            className="genericLink trunc"
            href={parsedResult.fullUrl}
            target="_blank"
            onClick={e => {
              e.stopPropagation();
            }}
          >
            {parsedResult.handle ?? this.props.value}
          </a>
        );
      case 'string':
      case 'text':
      case 'short_text':
      case 'long_text':
      case 'single_select':
      case 'email':
      case 'url':
        return this.renderText(this.props.value, this.props.field);
      case 'number':
        return this.props.value;
      case 'percentage':
        return this.props.value; // TODO: Removing '%' temporarily while we have customers using this field for decimal places
      case 'currency':
        let customRateAmount = this.props.value
          ? convertToWholeUnit(this.props.value.amount)
          : null;
        return `${currencyFormatter(
          null,
          get(this.props.value, 'currency')
        ).format(customRateAmount)}
          ${get(this.props.value, 'rate_interval') || ''}`;
      case 'locations':
        return get(this.props.value, [0, 'name']);
      case 'location':
        return this.props.value;
      case 'group':
        return (
          <TagGroup
            className="fill"
            tags={this.props.value}
            tagType="name"
            limit={4}
          />
        );
      case 'tag':
      case 'tags':
      case 'multi_select':
        return (
          <TagGroup
            className="fill"
            tags={this.props.value}
            tagType="tag"
            limit={4}
          />
        );
      case 'star_rating':
      case 'rating':
        return (
          <StarRating className="StarRating-custom" value={this.props.value} />
        );
      case 'dimension_2d':
        return displayDimension(this.props.value);
      case 'dimension_3d':
        return displayDimension(this.props.value);
      case 'measurement':
        return displayMeasurement(this.props.value);
      case 'measurement_new':
        if (typeof this.props.value === 'number') {
          return 'whoops we expect UnitField value here';
        }
        return unitFieldUtils.formatDisplay(this.props.value);
      case 'date':
        return moment(this.props.value).format('Do MMM YYYY');
      case 'date_range':
        return displayDateRange(this.props.value);
      case 'height':
        const heightValue = convertInchesToFeet(this.props.value);
        return `${
          heightValue.feetValue ? `${heightValue.feetValue}ft` : '--'
        } ${heightValue.inchValue ? `${heightValue.inchValue}in` : ''}`;
      case 'files':
        return;
      default:
        return this.renderText(this.props.value, this.props.field);
    }
  };
  renderValue = () => {
    return (
      <div className="RosterTable-row-cellContent">{this.renderCellType()}</div>
    );
  };
  render() {
    const { className } = this.props;

    return (
      <div className={classnames([className, 'RosterTable-row', 'Cell'])}>
        {this.renderValue()}
      </div>
    );
  }
}
